import {AxiosInstance} from "axios";
import API from "../../utils/api";
import {PaginatedRequest} from "../../models/core/paginated.request";
import {PaginatedResult} from "../../models/core/paginated.result";
import {
    PickupAuthorization
} from "../../models/accounts/customer-account/wholesale-account/wholesale.account.pickup-authorizations";

export class AccountPickupAuthorizationsService {
    api: AxiosInstance = API;

    getAll(accountId: number): Promise<PickupAuthorization[]> {
        return this.api.get<PickupAuthorization[]>("accounts/" + accountId + "/pickup-authorizations/all").then(x => x.data);
    }

    getPaginated(request: PaginatedRequest, accountId: number): Promise<PaginatedResult<PickupAuthorization>> {
        return this.api.get<PaginatedResult<PickupAuthorization>>("accounts/" + accountId + "/pickup-authorizations", {
            params: request.toParams()
        }).then(x => x.data);
    }

    create(accountId: number, data: any): Promise<PickupAuthorization> {
        return this.api.post("accounts/" + accountId + "/pickup-authorizations", data).then(x => x.data);
    }

    update(id: number, data: any): Promise<PickupAuthorization> {
        return this.api.post("accounts/pickup-authorizations/" + id, data).then(x => x.data);
    }

    remove(id: number): Promise<void> {
        return this.api.delete("accounts/pickup-authorizations/" + id);
    }

    setDefault(id: number): Promise<void> {
        return this.api.post("accounts/pickup-authorizations/" + id +  "/set-default");
    }
}

export const accountPickupAuthorizationsService = new AccountPickupAuthorizationsService();
